type RidgeDividerProps = {
  className?: string;
};

/**
 * A single shallow arc — the fingerprint ridge — used in place of a flat
 * hairline `border-t` between sections (see the mockup's `.arc-div`).
 * Reserved for the Home page's major section breaks; every other page
 * keeps its plain hairline so this stays a rare, confident accent rather
 * than a repeated motif.
 */
export const RidgeDivider = ({ className }: RidgeDividerProps) => (
  <svg
    viewBox="0 0 1080 14"
    preserveAspectRatio="none"
    fill="none"
    aria-hidden="true"
    className={`stroke-line block h-3.5 w-full ${className ?? ''}`}
  >
    <path d="M0 12 Q 540 0 1080 12" strokeWidth="1.4" />
  </svg>
);
